export default __webpack_public_path__ + "static/media/triangle_down.deed7e77.svg";